import {Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService} from '../_services';
import {FormBuilder, Validators} from '@angular/forms';
import {Form} from '../_forms';
import {StripeService} from "ngx-stripe";
import {
  StripeElements,
  StripeCardElement,
  StripeCardElementOptions,
  StripeElementsOptions
} from '@stripe/stripe-js';
import {takeUntil} from "rxjs/operators";
import {AddressFieldsComponent} from "../address";
import {StripeAccountType} from '../_models';
import {environment} from '../../environments/environment';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-credit-card-new-fields',
  templateUrl: './credit-card-new-fields.component.html'
})
export class CreditCardNewFieldsComponent extends Form implements OnInit, AfterViewInit {
  elements: StripeElements;
  card: StripeCardElement;
  @ViewChild('card', { static: false }) cardRef: ElementRef;
  @ViewChild(AddressFieldsComponent, { static: false }) addressFields: AddressFieldsComponent;
  @Input('accountType') accountType: StripeAccountType = StripeAccountType.Main;

  private cardOptions: StripeCardElementOptions = {
    style: {
    },
    hidePostalCode: true
  };

  private elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  constructor(
    private formBuilder: FormBuilder,
    protected router: Router,
    protected location: Location,
    protected alertService: AlertService,
    private stripeService: StripeService,
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [null, Validators.required],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.form.addControl('address', this.addressFields.form), 0);

    if (this.accountType === StripeAccountType.Gateway) {
      this.stripeService.setKey(environment.stripeGatewayPublicKey);
    } else {
      this.stripeService.setKey(environment.stripePublicKey);
    }

    this.stripeService.elements(this.elementsOptions)
      .pipe(takeUntil(this.destroy$))
      .subscribe(elements => {
        this.elements = elements;
        // Only mount the element the first time
        if (!this.card && this.cardRef) {
          this.card = this.elements.create('card', this.cardOptions);
          this.card.mount(this.cardRef.nativeElement);
        }
      });
  }

  createToken() {
    const value = Object.assign({name: this.form.value.name}, {
      address_line1: this.addressFields.form.value.address1 || '',
      address_line2: this.addressFields.form.value.address2 || '',
      address_city: this.addressFields.form.value.city || '',
      address_state: this.addressFields.form.value.state || '',
      address_zip: this.addressFields.form.value.zip || '',
      address_country: this.addressFields.form.value.country,
    });
    return this.stripeService.createToken(this.card, value);
  }
}
